<template>
  <div class="weather-container">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading">Loading...</div>

    <!-- 错误提示 -->
    <div v-if="error" class="error">{{ error }}</div>

    <!-- 天气信息展示 -->
    <div v-if="weatherData" class="weather-info">
      <h2>{{ weatherData.name }}, {{ weatherData.sys.country }}</h2>
      <div class="weather-main">
        <img
          :src="`https://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`"
          :alt="weatherData.weather[0].description"
        />
        <p class="temperature">{{ Math.round(weatherData.main.temp) }}°C</p>
      </div>
      <p>{{ getAdvice }}</p>
      <p class="description">{{ weatherData.weather[0].description }}</p>
      <div class="details">
        <p>湿度: {{ weatherData.main.humidity }}%</p>
        <p>风速: {{ weatherData.wind.speed }} m/s</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WeatherInfo",
  data() {
    return {
      loading: true,
      error: null,
      ip: null,
      location: null,
      weatherData: null,
    };
  },
  created() {
    this.fetchWeather();
  },
  computed: {
    //关于温度给出是否建议外出提示
    getAdvice() {
      var str = "";
      const temp = this.weatherData.main.temp; //温度
      const visibility = this.weatherData.visibility; //能见度
      const weather = this.weatherData.weather[0].id; //天气
      // 2xx: 雷暴 (如 200=小雨雷暴)
      // 3xx: 毛毛雨/细雨
      // 5xx: 降雨 (如 500=小雨)
      // 6xx: 降雪
      // 7xx: 特殊天气 (如 701=薄雾)
      // 800: 晴天
      // 80x: 多云 (如 801=少云)
      const windSpeed = this.weatherData.wind.speed; //风速
      if ([212, 502, 602, 711, 781].includes(weather)) {
        str = "⚠️ 极端天气警告！不建议外出";
      }

      let weatherScore; //天气类型评分
      if (weather >= 200 && weather < 300) {
        weatherScore = 30; // 雷暴
      } else if (weather >= 300 && weather < 600) {
        weatherScore = 40; // 降雨/雪
      } else if (weather >= 600 && weather < 700) {
        weatherScore = 50; // 降雪
      } else if (weather >= 700 && weather < 800) {
        weatherScore = 60; // 特殊天气（雾/尘等）
      } else if (weather === 800) {
        weatherScore = 100; // 晴天
      } else {
        weatherScore = 70; // 多云
      }
      // 3. 温度舒适度评分（0-100分）
      let tempScore;
      if (temp < -10) {
        tempScore = 20; // 极寒
      } else if (temp < 0) {
        tempScore = 40; // 寒冷
      } else if (temp < 15) {
        tempScore = 70; // 凉爽
      } else if (temp < 25) {
        tempScore = 100; // 舒适
      } else if (temp < 32) {
        tempScore = 60; // 炎热
      } else {
        tempScore = 30; // 酷热
      }
      // 4. 能见度评分（0-100分）
      const visibilityScore = Math.min(100, visibility * 10); // 每公里10分

      // 5. 风速评分（0-100分）
      let windScore;
      if (windSpeed > 20) {
        windScore = 0; // 狂风
      } else if (windSpeed > 10) {
        windScore = 30; // 大风
      } else if (windSpeed > 5) {
        windScore = 70; // 微风
      } else {
        windScore = 100; // 无风
      }
      // 综合评分（加权计算）
      const totalScore =
        weatherScore * 0.4 +
        tempScore * 0.3 +
        visibilityScore * 0.2 +
        windScore * 0.1;
      // 结果判断
      if(totalScore >= 80){
        str = '✅ 非常适合外出！天气晴朗舒适'
      }
      else if(totalScore >= 60){
        str = '☑️ 可以外出，但建议做好防护'
      }
      else if(totalScore >= 40){
        str = '❌ 不建议外出，天气条件较差'
      }
      else{
        str = '⛔ 绝对不要外出！存在安全隐患'
      }
      return str;
    },
    computed: {
      showHappyPet() {
        return (
          this.weatherData.main.temp > 15 &&
          this.weatherData.weather[0].main !== "Rain"
        );
      },
      outdoorLabel() {
        return this.showHappyPet ? "适宜外出" : "建议室内";
      },
    },
  },
  methods: {
    async fetchWeather() {
      try {
        // 步骤1: 获取用户IP地址
        const ipResponse = await axios.post(
          "https://restapi.amap.com/v3/ip?key=4fc18428373c4cce0f3d6aeb353d1432"
        );
        this.ip = ipResponse.data.city;
        // 步骤2:
        // "rectangle": "118.4253323,31.80452471;119.050169,32.39401346"
        this.location = ipResponse.data.rectangle;
        const rectangleArr = this.location.split(";");
        // 提取两个坐标点的经纬度
        const point1 = rectangleArr[0].split(",");
        const lat1 = parseFloat(point1[0]); // 第一个点的纬度
        const lng1 = parseFloat(point1[1]); // 第一个点的经度
        const point2 = rectangleArr[1].split(",");
        const lat2 = parseFloat(point2[0]); // 第二个点的纬度
        const lng2 = parseFloat(point2[1]); // 第二个点的经度
        // 计算中点坐标
        const midLat = (lat1 + lat2) / 2;
        const midLng = (lng1 + lng2) / 2;
        // 输出中点坐标
        // console.log(`中点坐标: 纬度 = ${midLat}, 经度 = ${midLng}`);
        // 步骤3: 根据地理位置获取天气信息
        //https://api.heweather.net/v7/weather/now?location=nanjing&key=f749e485522760282d51aba987bf92c4
        //https://api.openweathermap.org/data/2.5/weather?lat=39.9042&lon=116.4074&appid=7081da75348926b9bc4d7121aa89f7e0
        //https://api.openweathermap.org/data/2.5/weather?lat=32.0615513&lon=118.7915619&appid=7081da75348926b9bc4d7121aa89f7e0&units=metric
        const weatherResponse = await axios.get(
          `/weather/data/2.5/weather?lat=${midLng}&lon=${midLat}&appid=7081da75348926b9bc4d7121aa89f7e0&units=metric&lang=zh_cn`
        );
        this.weatherData = weatherResponse.data;
      } catch (err) {
        this.error = "无法获取天气信息，请稍后重试";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.weather-container {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: 100%;
  border: 1px solid rgba(64, 158, 255, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.weather-container:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(to bottom, #64b5f6, #81c784);
  border-radius: 0 3px 3px 0;
}

.loading,
.error {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: 14px;
}

.weather-info {
  text-align: center;
  width: 100%;
}

.weather-info h2 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 10px;
  font-weight: 500;
}

.weather-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin: 15px 0;
}

.weather-main img {
  transition: transform 0.3s;
  filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.1));
}

.weather-main:hover img {
  transform: scale(1.05) rotate(5deg);
}

.temperature {
  font-size: 2.2rem;
  font-weight: bold;
  margin: 0;
  background: linear-gradient(45deg, #409eff, #64b5f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

p {
  margin: 10px 0;
  color: #606266;
}

.description {
  text-transform: capitalize;
  color: #606266;
  margin: 10px 0 15px;
  font-weight: 500;
}

.details {
  display: flex;
  justify-content: space-around;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  margin-top: 15px;
  backdrop-filter: blur(5px);
  width: 100%;
}

.details p {
  margin: 0;
  color: #444;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.details p:first-child:before {
  content: "\e79f"; /* Element UI 湿度图标 */
  font-family: element-icons !important;
  margin-right: 5px;
  color: #64b5f6;
}

.details p:last-child:before {
  content: "\e781"; /* Element UI 风图标 */
  font-family: element-icons !important;
  margin-right: 5px;
  color: #64b5f6;
}
</style>
